import React from "react";

interface DividerProps {
  children?: React.ReactNode;
  padding?: number;
}

export default function Divider({ children }: DividerProps) {
  return (
    <div className="relative flex items-center">
      <div className="flex-grow border-t border-white border-opacity-10" />
      <span className={`flex-shrink ${children ? "mx-4" : ""} text-white`}>
        {children}
      </span>
      <div className="flex-grow border-t border-white border-opacity-10" />
    </div>
  );
}
